import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "chevron-down-icon",
  "aria-label": "Chevron down icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.5303 18.0303C12.2374 18.3232 11.7626 18.3232 11.4697 18.0303L2.46967 9.03033C2.17678 8.73744 2.17678 8.26256 2.46967 7.96967C2.76256 7.67678 3.23744 7.67678 3.53033 7.96967L12 16.4393L20.4697 7.96967C20.7626 7.67678 21.2374 7.67678 21.5303 7.96967C21.8232 8.26256 21.8232 8.73744 21.5303 9.03033L12.5303 18.0303Z"
    }, null, -1)
  ])))
}
export default { render: render }